// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/address.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message core.v1.Address
 */
export interface Address {
    /**
     * @generated from protobuf field: core.v1.Province province = 1;
     */
    province: Province;
}
/**
 * @generated from protobuf enum core.v1.Province
 */
export enum Province {
    /**
     * @generated from protobuf enum value: PROVINCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROVINCE_ALBERTA = 1;
     */
    ALBERTA = 1,
    /**
     * @generated from protobuf enum value: PROVINCE_BRITISH_COLUMBIA = 2;
     */
    BRITISH_COLUMBIA = 2,
    /**
     * @generated from protobuf enum value: PROVINCE_MANITOBA = 3;
     */
    MANITOBA = 3,
    /**
     * @generated from protobuf enum value: PROVINCE_NEW_BRUNSWICK = 4;
     */
    NEW_BRUNSWICK = 4,
    /**
     * @generated from protobuf enum value: PROVINCE_NEWFOUNDLAND_AND_LABRADOR = 5;
     */
    NEWFOUNDLAND_AND_LABRADOR = 5,
    /**
     * @generated from protobuf enum value: PROVINCE_NORTHWESTERN_TERRITORIES = 6;
     */
    NORTHWESTERN_TERRITORIES = 6,
    /**
     * @generated from protobuf enum value: PROVINCE_NOVA_SCOTIA = 7;
     */
    NOVA_SCOTIA = 7,
    /**
     * @generated from protobuf enum value: PROVINCE_NUNAVUT = 8;
     */
    NUNAVUT = 8,
    /**
     * @generated from protobuf enum value: PROVINCE_ONTARIO = 9;
     */
    ONTARIO = 9,
    /**
     * @generated from protobuf enum value: PROVINCE_PRINCE_EDWARD_ISLAND = 10;
     */
    PRINCE_EDWARD_ISLAND = 10,
    /**
     * @generated from protobuf enum value: PROVINCE_QUEBEC = 11;
     */
    QUEBEC = 11,
    /**
     * @generated from protobuf enum value: PROVINCE_SASKATCHEWAN = 12;
     */
    SASKATCHEWAN = 12,
    /**
     * @generated from protobuf enum value: PROVINCE_YUKON = 13;
     */
    YUKON = 13
}
// @generated message type with reflection information, may provide speed optimized methods
class Address$Type extends MessageType<Address> {
    constructor() {
        super("core.v1.Address", [
            { no: 1, name: "province", kind: "enum", T: () => ["core.v1.Province", Province, "PROVINCE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Address
 */
export const Address = new Address$Type();
